import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import ValidatedFormField from '../form/ValidatedField';

function PhoneNumber (props) {
    return (
        <div className="phone-number">
            <ValidatedFormField
                { ...props }
                type="tel"
                id="contactPhoneNumber"
                field={ props.field }
                label={ t('customerdetails.telephone') }
                placeholder={ props.placeholder }
                labelClassName="sr-only"
            />
        </div>
    );
}

PhoneNumber.propTypes = {
    ..._.pick(ValidatedFormField.propTypes, [
        'form',
        'onChange',
        'disabled',
        'required',
        'visited',
        'validation',
    ]),
    // Explicitly declare these so the linter sees them:
    field: PropTypes.string,
    placeholder: PropTypes.string,
};

PhoneNumber.defaultProps = {
    field: 'phone',
    placeholder: t('customerdetails.telephone'),
};

export default PhoneNumber;
